import React, { useEffect } from "react";
import { FaTimesCircle, FaRedo, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function PaymentFailed() {
  const navigate = useNavigate();
  useEffect(()=>{
 document.title = 'Failed';
  },[]);

  const styles = {
    page: {
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      background: "#ffffff", // white background
      padding: "20px",
      textAlign: "center",
      color: "#333",
    },

    iconCircle: {
      width: "120px",
      height: "120px",
      borderRadius: "50%",
      background: "rgba(255, 50, 50, 0.15)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "55px",
      color: "#FF3B3B",
      boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
      marginBottom: "25px",
      animation: "pop 0.6s ease",
    },

    title: {
      fontSize: "2.5rem",
      fontWeight: 700,
      marginBottom: "10px",
      color: "#FF3B3B",
    },

    subtitle: {
      fontSize: "1.2rem",
      opacity: 0.8,
      marginBottom: "30px",
    },

    message: {
      fontSize: "1.1rem",
      maxWidth: "600px",
      margin: "0 auto 35px",
      lineHeight: "1.6",
      color: "#555",
    },

    buttons: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      flexWrap: "wrap",
    },

    btnPrimary: {
      padding: "14px 38px",
      borderRadius: "50px",
      fontSize: "1rem",
      fontWeight: 700,
      background: "linear-gradient(135deg, #FF3B3B, #FF7676)",
      color: "white",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      transition: "0.3s",
      boxShadow: "0 5px 15px rgba(255,0,0,0.3)",
    },

    btnSecondary: {
      padding: "14px 38px",
      borderRadius: "50px",
      fontSize: "1rem",
      fontWeight: 700,
      background: "#ffffff",
      border: "2px solid #FF3B3B",
      color: "#FF3B3B",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      transition: "0.3s",
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes pop {
            0% { transform: scale(0.5); opacity: 0 }
            100% { transform: scale(1); opacity: 1 }
          }
        `}
      </style>

      <div style={styles.page}>
        <div style={styles.iconCircle}>
          <FaTimesCircle />
        </div>

        <h1 style={styles.title}>Payment Failed</h1>
        <p style={styles.subtitle}>Something went wrong ❗</p>

        <p style={styles.message}>
          Your payment could not be processed at this time. 
          This might be due to network issues, insufficient balance, or 
          incorrect payment details. Please try again.
        </p>

        <div style={styles.buttons}>
          <button
            style={styles.btnPrimary}
            onMouseOver={(e) => (e.target.style.opacity = "0.85")}
            onMouseOut={(e) => (e.target.style.opacity = "1")}
            onClick={() => navigate("/cart")}
          >
            <FaRedo /> Try Again
          </button>

          <button
            style={styles.btnSecondary}
            onMouseOver={(e) => {
              e.target.style.background = "#FF3B3B";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "#fff";
              e.target.style.color = "#FF3B3B";
            }}
            onClick={() => navigate("/")}
          >
            <FaHome /> Go Home
          </button>
        </div>
      </div>
    </>
  );
}
